import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { LoginBarFieldWUT } from '../../../ui/login-bar/login-bar';
export const BookingsLoginBarWUT = props => {
  const {
    fieldType = FIELD_TYPES.BOOKINGS_LOGIN_BAR
  } = props;
  return /*#__PURE__*/React.createElement(LoginBarFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=bookings-login-bar-wut.js.map